<template>
	<div class="devices">
	  <el-row>
	    <el-col :span="22" :offset="1">
	      <ul class="device-items d-flex justify-content-space-around">
	        <li v-for="(item, index) in productIcons" class="d-flex column align-items-center justify-content-center device-item">
	          <img :src="item.icon_url" class="device-item_icon" />
	          <a class="device-item_title">{{item.title}}</a>
	        </li>
	      </ul>
	    </el-col>
	  </el-row>
	</div>
</template>

<script setup>
	import iconWindows from '@/assets/images/platform/windows.png'
	import iconMac from '@/assets/images/platform/mac.png'
	import iconIos from '@/assets/images/platform/iOS.png'
	import iconAndroid from '@/assets/images/platform/android.png'
	import iconMp from '@/assets/images/platform/mp.png'
	
	const productIcons = ref([
        { icon_url: iconWindows, title: 'Windows 端', url: ''},
		{ icon_url: iconMac, title: 'Mac 端', url: ''},
        { icon_url: iconIos, title: 'iOS App', url: ''},
        { icon_url: iconAndroid, title: 'Android App', url: ''},
        { icon_url: iconMp, title: '微信小程序', url: ''}
      ])
</script>

<style lang="scss" scoped>
	.devices {
		background-color: #fd5e0f;
		color: #FFFFFF;
		padding: 15px 0;
		margin-bottom: 1rem;
		
		.device-item_icon {
			height: 3.5rem;
			width: 3.5rem;
		}
		
		.device-item_title {
			margin-top: .5rem;
		}
	}
</style>